import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import SingleProfile from './views/SingleProfileView.vue'
import OtherWebsite from './views/OtherWebsiteView.vue'
import CustomWebsite from './views/CustomWebsiteView.vue'
import Onboarding from './views/OnboardingView.vue'
import Profile from './views/Profile.vue'
import LinkedinCompanyView from './views/LinkedinCompanyView.vue'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/single',
      name: 'SingleProfile',
      component: SingleProfile
    },
    {
      path: '/bulk',
      name: 'Bulk',
      component: Home
    },
    {
      path: '/website',
      name: 'Other Website',
      component: OtherWebsite
    },
    {
      path: '/custom',
      name: 'Custom Website',
      component: CustomWebsite
    },
    {
      path: '/start',
      name: 'Onboarding',
      component: Onboarding
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/company',
      name: 'Company',
      component: LinkedinCompanyView
    }
  ]
})

router.afterEach(() => {
  Vue.nextTick(() => {
    document.title =
      window.location.pathname === '/company'
        ? 'Adapt Company Crawler'
        : 'Adapt Prospector'
  })
})

export default router
